import { render, staticRenderFns } from "./BottomMenu.vue?vue&type=template&id=3b443e0a"
import script from "./BottomMenu.vue?vue&type=script&lang=js"
export * from "./BottomMenu.vue?vue&type=script&lang=js"
import style0 from "./BottomMenu.vue?vue&type=style&index=0&id=3b443e0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports